import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import Logo from '../Hero/Logo';

const HeaderVariant = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const isClientPage = location.pathname === '/client';
  const isChauffeurPage = location.pathname === '/chauffeur';
  const isCareerPage = location.pathname === '/career';
  const isAboutPage = location.pathname === '/about';

  const getButtonStyles = (isActive) => {
    return `relative text-white hover:text-gray-300 transition-colors text-lg ${
      isActive ? 'after:content-[""] after:absolute after:bottom-[-4px] after:left-0 after:w-full after:h-[2px] after:bg-white' : ''
    }`;
  };

  const menuItems = [
    { name: 'Client', path: '/client', isActive: isClientPage },
    { name: 'Chauffeur', path: '/chauffeur', isActive: isChauffeurPage },
    { name: 'Career', path: '/career', isActive: isCareerPage },
    { name: 'About Us', path: '/about', isActive: isAboutPage },
  ];

  return (
    <header className="z-50 bg-black border-b border-white/10">
      <div className="max-w-7xl mx-auto px-4 py-4">
        <div className="flex justify-between items-center md:justify-center md:space-x-12">
          <button 
            onClick={() => navigate('/')}
            className="hover:opacity-80 transition-opacity"
          >
            <Logo size="small" className="w-[45px] md:w-[55px]" />
          </button>
          
          {/* Mobile Menu Button */}
          <button 
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="md:hidden text-white w-8 h-8 relative focus:outline-none z-50"
          >
            <div className="space-y-2">
              <span className={`block w-8 h-0.5 bg-white transform transition-all duration-300 ${isMenuOpen ? 'rotate-45 translate-y-2.5' : ''}`}></span>
              <span className={`block w-8 h-0.5 bg-white transition-all duration-300 ${isMenuOpen ? 'opacity-0' : ''}`}></span>
              <span className={`block w-8 h-0.5 bg-white transform transition-all duration-300 ${isMenuOpen ? '-rotate-45 -translate-y-2.5' : ''}`}></span>
            </div>
          </button>
          
          {/* Desktop Navigation */}
          <div className="hidden md:flex space-x-12">
            {menuItems.map((item) => (
              <button 
                key={item.name}
                onClick={() => navigate(item.path)}
                className={getButtonStyles(item.isActive)}
              >
                {item.name}
              </button>
            ))}
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      <AnimatePresence>
        {isMenuOpen && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.2 }}
            className="fixed inset-0 bg-black/95 z-40 md:hidden"
          >
            <nav className="flex flex-col items-center justify-center h-full space-y-8">
              {menuItems.map((item) => (
                <motion.button
                  key={item.name}
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  exit={{ opacity: 0, y: 20 }}
                  transition={{ duration: 0.3 }}
                  onClick={() => {
                    navigate(item.path);
                    setIsMenuOpen(false);
                  }}
                  className={`text-xl font-medium ${
                    item.isActive ? 'text-white' : 'text-gray-400'
                  } hover:text-white transition-colors`}
                >
                  {item.name}
                </motion.button>
              ))}
            </nav>
          </motion.div>
        )}
      </AnimatePresence>
    </header>
  );
};

export default HeaderVariant; 